import { render, staticRenderFns } from "./EventsViewTest.vue?vue&type=template&id=6dfee75a&scoped=true&"
import script from "./EventsViewTest.vue?vue&type=script&lang=js&"
export * from "./EventsViewTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfee75a",
  null
  
)

export default component.exports